import { Action } from "@ngrx/store";
import { UserDto } from "@merchant_api/models/user-dto";

export enum ActionTypes {
    GetUsers = "[Users] GetUsers",
    GetUsersSucceed = "[Users] GetUsersSucceed",
    GetUsersFail = "[Users] GetUsersFail"
}

export class GetUsersAction implements Action {

    constructor() {}

    readonly type = ActionTypes.GetUsers;
}

export class GetUsersSucceedAction implements Action {

    constructor(public users: Array<UserDto>) {}

    readonly type = ActionTypes.GetUsersSucceed;
}

export class GetUsersFailAction implements Action {

    constructor(public error: any) {}

    readonly type = ActionTypes.GetUsersFail;
}
